import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { meQuery } from '@/api/queries/me'
import { computeGrants, primaryRole, resolvePermission, type PermissionName } from './permissions'

/**
 * The current user's permissions, from GET /admin/v1/me.
 *
 *   const { can } = usePermissions()
 *   <Button disabled={!can('edit_content')}>Publish</Button>   // or the alias 'edit'
 *
 * While /me is loading, `can()` returns false (actions appear once known).
 */
export function usePermissions() {
  const me = useQuery(meQuery)
  return useMemo(() => {
    const grants = computeGrants(me.data)
    return {
      me: me.data,
      isLoading: me.isPending,
      error: me.error,
      roles: grants.roles,
      role: primaryRole(grants.roles),
      can: (p: PermissionName) => grants.permissions.has(resolvePermission(p)),
    }
  }, [me.data, me.isPending, me.error])
}
